module.exports = __webpack_public_path__ + "background27.jpg?f132135ee0df57c09293b19dd13e8a00";